import { Link, useLocation } from "react-router-dom";
import { scrollToId, scrollToTop } from "../lib/scroll";

// Link a la landing o a una sección (ej: id="#pricing"; id="/" o vacío = tope/Inicio).
// - Si ya estás en la landing: scrollea con Lenis al instante (funciona aunque
//   sea la misma sección o Inicio) y ajusta la URL sin recargar ni pelear con Lenis.
// - Si estás en otra página: navega y el ScrollManager hace el scroll al montar.
export const HashLink = ({ id, onClick, children, ...props }) => {
  const { pathname } = useLocation();
  const isTop = !id || id === "/" || id === "#";
  const to = isTop ? "/" : `/${id}`;

  const handle = (e) => {
    if (pathname === "/") {
      e.preventDefault();
      window.history.replaceState(null, "", to);
      // Difiere el scroll para que, si venimos del menú, el bloqueo de scroll
      // del body ya se haya liberado (evita que Lenis quede clavado).
      setTimeout(() => (isTop ? scrollToTop() : scrollToId(id)), 90);
    }
    if (onClick) onClick(e);
  };

  return (
    <Link to={to} onClick={handle} {...props}>
      {children}
    </Link>
  );
};
